import React, {useContext} from "react";
import {connect} from "react-redux";

import JobEditPopupContext from "./JobEditPopupContext";
import PricingCheckbox from "../../Pricing/PricingComponents/PricingCheckbox";
import {DASHBOARD_MESSAGING_ACTIONS, sendIframePostMessage} from "./jobIframeMessaging";
import {setJobUseFabricatorCostPrices, setJobUseTaxes} from "./jobEditActions";
import {getTaxTotal, toFixedPrice} from "./jobPricingFunctions";


const JobEditPopupInfoBar = (props) => {

  const {jobTotal, setJobUseFabricatorCostPrices, jobUseFabricatorCostPrices, jobUseTaxes, setJobUseTaxes} = props;

  const {iframeElement} = useContext(JobEditPopupContext);

  const onChangeCost = () => {
    setJobUseFabricatorCostPrices(!jobUseFabricatorCostPrices) // update front
    sendIframePostMessage(iframeElement, {
      action: DASHBOARD_MESSAGING_ACTIONS.setCostPrices,
      payload: !jobUseFabricatorCostPrices
    })
  }

  return (
    <div className="pl-1 pr-1 mb-1 flex flex--center flex--between">
      <div className="flex font--15 bold ml-075">
        <div className="mr-1">
          Total: {jobUseTaxes ? "$" + toFixedPrice(jobTotal.totalWithTaxes) : "$" + toFixedPrice(jobTotal.materialCost)}
        </div>
        <div className="">Taxes: {jobUseTaxes ? "$" + toFixedPrice(getTaxTotal(jobTotal)) : 0}</div>
      </div>
      <div className="pr-grid--light flex flex--center">
        <PricingCheckbox id={"useTaxes"}
                         text={"Use Taxes"}
                         className="noselect mr-1 pr-checkbox--white min-h-125 flex flex--center flex--start"
                         checked={jobUseTaxes}
                         onChange={() => setJobUseTaxes(!jobUseTaxes)}/>
        <PricingCheckbox id={"costPrices"}
                         text={"Use Cost Price"}
                         className="noselect pr-checkbox--white min-h-125 flex flex--center flex--start"
                         checked={jobUseFabricatorCostPrices}
                         onChange={onChangeCost}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {jobTotal, jobUseFabricatorCostPrices, jobUseTaxes} = store.jobEditPopupState;
  return {
    jobTotal,
    jobUseFabricatorCostPrices,
    jobUseTaxes,
  };
};

const mapDispatchToProps = {
  setJobUseFabricatorCostPrices,
  setJobUseTaxes,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobEditPopupInfoBar)
)
